import React  from 'react';
const value = {
  path:"property_types",
  title:"Property Types",
  date_modified:"July 2020",
  date_created:"July 2020",
  content:
[
<p align="justify">
There are three home-ownership types. It’s important to understand the pros and cons of each when buying a home. The three types are: freehold, leasehold, and strata.
</p>
,
<p class="content_sub_title">
Freehold
</p>
,
<p align="justify">
The freehold ownership type provides the buyer with the most amount of control over their property -- at a cost, of course. Owners of a freehold property own the building as well as the land it is situated on. Freehold properties are more expensive than either of the alternatives, but the appreciation is more favourable -- not to mention the owner is able to sell and/or renovate whenever they want. The majority of detached homes are freehold.
</p>
,
<p class="content_sub_title">
Leasehold
</p>
,
<p align="justify">
The difference between leasehold and freehold is that if you own a leasehold property, you do not own the land: you are leasing it. The length of the lease is typically 99 years. This is a fine arrangement for residents at the beginning of the lease period, but as you can imagine, it becomes a stressful situation for whoever is residing there at the end of the lease period. At the end of their lease, building owners could face eviction or a steep rise in lease cost. Some detached houses as well as most mobile homes are owned via leasehold.
</p>
,
<p class="content_sub_title">
Strata
</p>
,
<p align="justify">
Strata properties are the least expensive to buy and own, but provide the owner with the least amount of control over their dwelling. Strata properties include condominiums and townhouses. In this arrangement, even though you would own the inside of your dwelling, you are still restricted to the strata rules. Often, strata owners will not be allowed to renovate, and have to abide by other restrictions including: the ability to rent your unit, pets you can keep, as well as age of residents. Strata properties include parts of the property that are owned jointly, for example a pool in a condominium building, or the shared driveway in a townhouse complex. Owners are required to pay fees to maintain these shared spaces. However, the maintenance costs of a strata property are typically cheaper than those of a freehold property -- since maintenance can be performed more efficiently.
</p>
],
  tags:["finding a house"]
}

export default value



// WEBPACK FOOTER //
// src/content/propertyTypes.js